/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Menuweekof2Inputs */

const en_menuweekof2 = /** @type {(inputs: Menuweekof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week of ${i?.date}`)
};

const de_menuweekof2 = /** @type {(inputs: Menuweekof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woche ab ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Week of {date}" |
*
* @param {Menuweekof2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuweekof2 = /** @type {((inputs: Menuweekof2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuweekof2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuweekof2(inputs)
	return de_menuweekof2(inputs)
});
export { menuweekof2 as "menuWeekOf" }